export const appointmentRequests = {
    namespaced: true,

    state: () => ({
        nav: {
            FCDClientIds: []
        },
    }),

    getters: {
        FCDClientIds(state) {
            return state.nav.FCDClientIds;
        },
    },

    mutations: {
        hydrateFCDClientIds(state,payload) {
            state.nav.FCDClientIds = payload;
        },
    },

};